var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"BoxContext"},[_c('router-link',{attrs:{"to":{name:'roots-in-soil'}}},[_c('img',{staticClass:"campaignImage",attrs:{"src":require("../../assets/webText.jpg"),"width":"100%","alt":""}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }